'use client';
import { jsx } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import { createPolymorphicComponent, Transition, FocusTrap, Box, CLASSNAME_FULL_WIDTH } from '@s7/base';
import { useProps } from '@s7/styles';
import { useModalContext } from '../Modal.context.js';
import { IDENT_MODAL_CONTENT, defaultProps } from './ModalContent.contract.js';
import { useModalContentProps } from './useModalContentProps.js';
import useStyles from './ModalContent.styles.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const _ModalContent = /*#__PURE__*/ forwardRef((props, ref)=>{
    const _useModalContext = useModalContext(), { zIndex, radius, padding, breakpoints, preset } = _useModalContext, context = _object_without_properties_loose(_useModalContext, [
        "zIndex",
        "radius",
        "padding",
        "breakpoints",
        "preset"
    ]);
    const _useProps = useProps(IDENT_MODAL_CONTENT, _extends({
        preset
    }, props), defaultProps), [{ transitionProps, className, onKeyDown, style, children }, sxs] = _useProps, others = _object_without_properties_loose(_useProps[0], [
        "transitionProps",
        "className",
        "onKeyDown",
        "style",
        "children"
    ]);
    const [classes, cx] = useStyles({
        zIndex,
        radius,
        padding,
        breakpoints
    }, sxs, IDENT_MODAL_CONTENT);
    const { focusTrapActive, contentProps } = useModalContentProps();
    return /*#__PURE__*/ jsx(Transition, _extends({
        mounted: context.opened,
        transition: "pop"
    }, context.transitionProps, transitionProps, {
        children: (transitionStyles)=>/*#__PURE__*/ jsx("div", {
                className: classes.inner,
                children: /*#__PURE__*/ jsx(FocusTrap, {
                    active: focusTrapActive,
                    children: /*#__PURE__*/ jsx(Box, _extends({}, others, contentProps, {
                        ref: ref,
                        className: cx(classes.content, className, /* Требует компенсации при сокрытии полосы прокрутки */ CLASSNAME_FULL_WIDTH),
                        /*
                             * Требуется именно такой порядок,
                             * когда необходимо динамически переопределять стили.
                             * См. SwipeableDrawer.
                             * */ style: _extends({}, transitionStyles, style),
                        children: children
                    }))
                })
            })
    }));
});
const ModalContent = createPolymorphicComponent(_ModalContent);
ModalContent.displayName = 'Modal.Content';

export { ModalContent };
//# sourceMappingURL=ModalContent.js.map
